import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class zohoService extends GenericService {
    constructor() {
        super('/zoho', axiosInstance);
    }

    async getSettings() {
        try {
          const response = await axiosInstance.get(`${this.baseUrl}/settings`);
          return response.data;
        } catch (error) {
          throw this.handleError(error);
        }
    }

    async saveSettings(data) {
        try {
            const response = await axiosInstance.post(`${this.baseUrl}/settings`, data);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getAuthorizeUrl() {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/authorize`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getAccessToken(data) {
        try {
            const response = await axiosInstance.post(`${this.baseUrl}/access-token`, data);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getOrganizations() {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/organizations`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async disconnect() {
        try {
            const response = await axiosInstance.post(`${this.baseUrl}/disconnect`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getAccounts() {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/accounts`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async saveAccountMapping(data) {
        try {
            const response = await axiosInstance.post(`${this.baseUrl}/settings/accounts`, data);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async saveContactTagMapping(data) {
        try {
            const response = await axiosInstance.post(`${this.baseUrl}/settings/contact-tags`, data);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getReportingTags() {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/reporting-tags`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async savePartialSettings(data) {
        try {
            const response = await axiosInstance.post(`${this.baseUrl}/settings`, data);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getValidationStatus() {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/settings/validation`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getAccountMappingDefinitions() {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/settings/account-mapping-definitions`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getReferenceCacheStatus() {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/settings/reference-cache`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async refreshReferenceCache() {
        try {
            const response = await axiosInstance.post(`${this.baseUrl}/settings/reference-cache/refresh`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getSyncStatus() {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/sync/status`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async getSyncFailures() {
        try {
            const response = await axiosInstance.get(`${this.baseUrl}/sync/failures`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async retrySync(failureId) {
        try {
            const response = await axiosInstance.post(`${this.baseUrl}/sync/retry`, {
                failure_id: failureId,
            });
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }

    async retryAllSync() {
        try {
            const response = await axiosInstance.post(`${this.baseUrl}/sync/retry-all`);
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }
}

export default new zohoService();
